/* this file is transformed by vux-loader */
/* eslint-disable */
import "core-js/modules/es.array.map.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import Swiper from "vux/src/components/swiper/swiper.vue";
import SwiperItem from "vux/src/components/swiper/swiper-item.vue";
import Previewer from "vux/src/components/previewer/index.vue";
import TransferDom from "vux/src/directives/transfer-dom/index.js";
export default {
  name: 'Banner',
  props: {
    bannerList: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  components: {
    Swiper: Swiper,
    SwiperItem: SwiperItem,
    Previewer: Previewer
  },
  directives: {
    TransferDom: TransferDom
  },
  data: function data() {
    return {
      picsForPreviewer: [],
      options: {
        getThumbBoundsFn: function getThumbBoundsFn(index) {
          var $$ = document.querySelectorAll.bind(document);
          var thumbnail = $$('.previewer-demo-img')[index];

          if (thumbnail) {
            var _thumbnail = $$('.previewer-demo-img')[index];
            var pageYScroll = window.pageYOffset || document.documentElement.scrollTop;

            if (_thumbnail.getBoundingClientRect) {
              var rect = _thumbnail.getBoundingClientRect();

              return {
                x: rect.left,
                y: rect.top + pageYScroll,
                w: rect.width
              };
            }
          }
        },
        shareEl: true,
        shareButtons: [{
          id: 'download',
          label: ' 下载图片 ',
          url: '{{raw_image_url}}',
          download: true
        }]
      }
    };
  },
  created: function created() {},
  mounted: function mounted() {},
  methods: {
    showPic: function showPic() {
      var _this = this;

      this.picsForPreviewer = [{
        src: require('@/assets/img/banner.png')
      }];
      this.$nextTick(function () {
        _this.$refs['previewer'].show(0);
      });
    },
    showBanner: function showBanner(index) {
      var _this2 = this;

      this.picsForPreviewer = this.bannerList.map(function (v) {
        return {
          src: v.img_url
        };
      });
      this.$nextTick(function () {
        _this2.$refs['previewer'].show(index);
      });
    }
  }
};